// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"36873838","389":"4a4964a4","488":"fbb3663d","732":"e19048aa","857":"ba4b83af","977":"73843196"}[chunkId] + ".chunk.js";
};